// extracted by css-extract-rspack-plugin
export default {"UpsellBannerComponent":"ju6eC","Large":"Il226"};